import React from "react";
import PropTypes from "prop-types";
import RcSlider from "rc-slider";
import "rc-slider/assets/index.css";

import tokens, { slider, overrides, tooltipArrow } from "./Slider.module.scss";

const SliderWithTooltip = RcSlider.createSliderWithTooltip(RcSlider);

const tooltipOverlayInnerStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "35px",
  height: "40px",
  borderRadius: "3px",
  backgroundColor: tokens.nightShade,
  fontFamily: tokens.tipFontFamily,
  fontSize: tokens.tipFontSize,
  letterSpacing: tokens.tipLetterSpacing,
  lineHeight: tokens.tipLineHeight,
  fontWeight: tokens.tipFontWeight,
  color: tokens.tipColor
};

const invocaRcSliderOverrides = {
  className: overrides,
  railStyle: {
    backgroundColor: tokens.black10,
    height: tokens.spacing3
  },
  trackStyle: { display: "none", height: tokens.spacing3 },
  handleStyle: {
    width: "18px",
    height: "18px",
    marginTop: "-6px",
    backgroundColor: tokens.green50,
    border: "3px solid white",
    boxShadow: tokens.shadow
  },
  dotStyle: { display: "none" },
  tipProps: {
    placement: "top",
    overlayInnerStyle: tooltipOverlayInnerStyle,
    arrowContent: <div className={tooltipArrow} />
  }
};

const Slider = ({ max, ...props }) => (
  <div className={slider}>
    <SliderWithTooltip
      {...invocaRcSliderOverrides}
      min={0}
      max={max}
      {...props}
    />
  </div>
);

Slider.propTypes = {
  max: PropTypes.number.isRequired
};

export { invocaRcSliderOverrides };

export default Slider;
